module.exports = __webpack_public_path__ + "static/media/TMT 1b.67438419.jpg";